// Vendors
import { apiUtils } from '@openbank/cf-ui-architecture-core';
//  Constants
import {
  COMPLETE_ACCOUNT_CHECK_SERVICE_CONFIGURATION,
  INVALIDATE_ACCOUNT_CHECK_SERVICE_CONFIGURATION,
} from './constants/kyc-method.service.constants';
// Types
import { GenericServiceType } from '@openbank/ziniaweb-ui-core-models';
import { KycApiBuilderType } from '../types/kyc-method-api-response.type';

const invalidateAccountCheckService = async (
  identificationId: string
): Promise<GenericServiceType<never>> =>
  apiUtils.post({
    ...INVALIDATE_ACCOUNT_CHECK_SERVICE_CONFIGURATION,
    pathParams: { ...INVALIDATE_ACCOUNT_CHECK_SERVICE_CONFIGURATION.pathParams, identificationId },
  });

const completeAccountCheckService = async ({
  kycIdentificationId: identificationId,
  reportIds,
}: KycApiBuilderType): Promise<GenericServiceType<never>> =>
  apiUtils.post({
    ...COMPLETE_ACCOUNT_CHECK_SERVICE_CONFIGURATION,
    params: {
      ...COMPLETE_ACCOUNT_CHECK_SERVICE_CONFIGURATION.params,
      accountVerificationReportId: reportIds.account_verification_report_id,
    },
    pathParams: { ...COMPLETE_ACCOUNT_CHECK_SERVICE_CONFIGURATION.pathParams, identificationId },
  });

export { completeAccountCheckService, invalidateAccountCheckService };
